import { DATA_STUDIO } from 'constants/routes';
import { serviceRoles } from 'config/access';
import { checkAccess } from 'helpers/auth';
import DataStudioPage from './container/DataStudioPage';

export default function getSettingsRoute(userAuth) {
  const { account } = serviceRoles;
  const requireAuth = {
    [account.name]: [
      account.roles.superadmin,
    ],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: DATA_STUDIO,
    withSidebar: true,
    withAppBar: true,
    component: DataStudioPage,
  };
}
